module.exports = __webpack_public_path__ + "static/media/crossRed.c5b429a6.png";